<template>
	<div class="lf-course">
		<div class="lf-course-flex">
			<div class="lf-course-img">
				<!-- <img :src="leftimg"> -->
				<!-- {{threeinfo}} -->
				<img :src="leftimg">
				<div class="img-message">{{Message}}</div>
			</div>
			<div class="lf-course-right-total">
				<div class="lf-course-right">
					<div class="lf-course-show">
						<div class="show-preview" @click="preview">PREVIEW</div>
						<div class="show-next" @click="nextcourse">
							<div class="next">NEXT</div>

							<div class="signRight">
								<SvgIcon svg-name="signRightWhite" size="50"></SvgIcon>
							</div>

						</div>
					</div>
					<div class="lf-course-map">
						<img :src="Mapimg" alt="">
					</div>
				</div>
				<div class="line-box">
					<div class="map-message">
						<div class="map-line">
							<div v-for="(item,i) in threeinfo">
								<div class="map-top">{{item.course_name}}</div>
								<div class="map-line-round">
									<div class="round-box">
										<div class="round" :class="{'active':numflag==i}"></div>
									</div>
									<div class="round-line"></div>
								</div>
								<!-- <div class="map-bottom" :class="{'active':numflag==i}">{{item.course_date}}</div> -->
								<div class="map-bottom" :class="{'active':numflag==i}">{{getCourseDate(item.course_date)}}</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import SvgIcon from './SvgIcon'
	import request from '../common/request.js'
	
	export default {
		name: 'LfCourse',
		data() {
			return {
				numflag: '0',
				threeinfo: [
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/1.jpg',
					// 	imgMessage: '乐范正式成立',
					// 	date: '2017年2月',
					// 	course: '2017年2月乐范正式成立',

					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/2.jpg',
					// 	imgMessage: '在厦门举办一维AI智能按摩椅发布会',
					// 	date: '2018年7月',
					// 	course: '一维按摩椅发布会',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/3.jpg',
					// 	imgMessage: '',
					// 	date: '2018年10月',
					// 	course: '小米生态链企业',
					// },
				],
				num: '0',
				// Courseimg: this.GLOBAL.imgHost + '/images/about/linktravel.png',
				Mapimg: this.GLOBAL.imgHost + '/images/about/map.png',
				arrow: this.GLOBAL.imgHost + '/images/about/arrow2.png',
				// imgMessage: '乐范联合曹操出行，为大家带来全新升级的按摩专车',
				// date: ['2019年9月', '2019年4月', '2019年1月'],
				course: ['乐范x曹操出行', '乐范亮相Yonion瑜伽节', '美国拉斯维加斯CES展会'],
				info: [
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/1.jpg',
					// 	imgMessage: '2017年2月乐范正式成立',
					// 	date: '2017年2月',
					// 	course: '乐范正式成立',

					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/2.jpg',
					// 	imgMessage: '在厦门举办一维AI智能按摩椅发布会',
					// 	date: '2018年7月',
					// 	course: '一维按摩椅发布会',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/3.jpg',
					// 	imgMessage: '',
					// 	date: '2018年10月',
					// 	course: '小米生态链企业',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/4.jpg',
					// 	imgMessage: '参加“让日本看到中国匠”中日新匠人交流展',
					// 	date: '2018年10月',
					// 	course: '中日新匠人',
					// },

					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/5.jpg',
					// 	imgMessage: '荣获UPSTYLE AWARD 2018上格奖',
					// 	date: '2018年10月',
					// 	course: '上格奖',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/6.jpg',
					// 	imgMessage: '通过国家高新技术认定',
					// 	date: '2018年10月',
					// 	course: '国家高新技术认定',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/7.jpg',
					// 	imgMessage: '入选“新匠人100”榜单，从全国数千名新匠人中脱颖而出，成为吴晓波频道新匠人加速计划的百匠之一',
					// 	date: '2019年1月',
					// 	course: '新匠人100',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/8.jpg',
					// 	imgMessage: '荣获小米有品最佳创新奖',
					// 	date: '2019年3月',
					// 	course: '小米有品最佳创新奖',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/9.jpg',
					// 	imgMessage: '荣获小米有品勤勉突破奖',
					// 	date: '2019年3月',
					// 	course: '小米有品勤勉奖',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/10.jpg',
					// 	imgMessage: '参加美国CES展会',
					// 	date: '2019年1月',
					// 	course: '参加美国CES展会',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/11.jpg',
					// 	imgMessage: '通过厦门科技小巨人领军企业认定',
					// 	date: '2019年7月',
					// 	course: '厦门科技小巨人领军企业认定',
					// },
					// {
					// 	img: this.GLOBAL.imgHost + '/images/lfcourse/12.jpg',
					// 	imgMessage: '荣获红点 “当代好设计”优胜奖',
					// 	date: '2019年11月',
					// 	course: '当代好设计',
					// },
				]
			}
		},

        created() {
			this.getCourseList()
		},		
		components: {
			SvgIcon
		},
		watch: {
			num(newValue, oldValue) {
				let that = this;
				if (newValue > oldValue) {
					if (that.numflag < 2) {
						that.numflag++
					} else {
						let array = []
						for (let i = newValue - 2; i <= newValue; i++) {
							array.push(that.info[i]);
						}
						that.threeinfo = array;
					}
				} else {
					if (that.numflag > 0) {
						that.numflag--
					} else {
						let array = []
						for (let i = newValue; i <= newValue + 2; i++) {
							array.push(that.info[i]);
						}
						that.threeinfo = array;
					}

				}
			}
		},
		computed: {
			leftimg() {
				// return this.threeinfo[this.numflag].img
				if(this.threeinfo[this.numflag]) {
					return this.threeinfo[this.numflag].course_img
				}
				

			},
			Message() {
				if(this.threeinfo[this.numflag]) {
					return this.threeinfo[this.numflag].course_img_desc
				}
				
			},
			// 历程时间格式化
			getCourseDate() {
				return function(date) {
					const dateArr = date.split('-')
					return dateArr[0] + '年' + Number.parseInt(dateArr[1]) + '月'
				}
			}

		},
		methods: {
			async getCourseList() {
				let res = await this.$Cloud.table(`lf_func_lefan_course`).get({ page: 0, pageSize: 1000,sort_by:'create_at',order_by:'asc' })
				
				const {code,data} = res
				if(code == 200) {
					this.threeinfo = data.slice(0,3).filter(item => item.is_check == 2)
					this.info = data.filter(item => item.is_check == 2)
				}
				
				console.log('历程列表====>>>>>',res)
				// request.uniRequest('/course/getCourseList')
				// 	.then(res => {
				// 		this.threeinfo = res.data.slice(0,3)
				// 		this.info = res.data
				// 		// console.log('test-----three',this.threeinfo);
				// 	}).catch(e => {})
			},
			nextcourse() {
				let that = this
				if (that.num < that.info.length-1) {
					that.num++
				}
			},
			preview() {
				let that = this
				if (that.num > 0) {
					that.num--
				}
			}
		}

	}
</script>

<style scoped>
	.lf-course {
		max-width: 90%;
		padding-right: 250px;
		margin-bottom: 60px;
		margin-top: 100px;
	}

	.lf-course-flex {
		display: flex
	}

	.lf-course-img {
		/* height: 300px; */
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 16px 32px 0px rgba(41, 44, 51, 0.1);
		font-size: 13px;
		text-align: left;
		padding-left: 8px;
		padding-right: 8px;
		padding-top: 8px;
		margin-left: 35px;

	}

	.lf-course-img img {

		height: 180px;

	}

	.lf-course-img .img-message {
		margin-top: 20px;
		font-weight: 400;
		
		font-size: 13px;
		color: rgba(64, 64, 64, 1);
	}

	.lf-course-show {
		display: flex;
		margin-top: 50px;
		margin-left: 32px;
		height: 60px;
	}

	.lf-course-show .show-preview {
		width: 100px;
		height: 52px;
		background: rgba(85, 85, 85, 1);
		font-size: 12px;
		 
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
	}

	.lf-course-show .show-next {
		width: 150px;
		height: 52px;
		background: linear-gradient(90deg, rgba(0, 199, 133, 1), rgba(9, 219, 184, 1));
		font-size: 12px;
		 
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 53px;
		margin-left: 3px;
		display: flex;
	}

	.lf-course-map {
		width: 40%;
		height: 350px;
	}

	.lf-course-map img {

		width: 125%;
	}

	.line-box {
		margin-top: -100px;
		margin-left: 32px;
	}

	.map-message {
		display: flex
	}

	.map-date-top div:nth-child(2),
	.map-date-top div:nth-child(3) {
		font-size: 17px;
		 
		font-weight: 500;
		color: rgba(164, 164, 164, 1);
		line-height: 53px;
	}

	.map-line {
		display: flex
	}


	.round-box {
		width: 10px;
		height: 12px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 3px 12px 0px rgba(41, 44, 51, 0.1);
		border-radius: 50%;


	}

	.round-box .round {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		margin: auto;
		background: rgba(164, 164, 164, 1)
	}

	.round-box .round.active {
		background: rgba(0, 199, 133, 1);
		font-weight: 550;
		border-bottom: 0.0625rem !important;
	}

	.round-line {
		width: 210px;
		height: 4px;
		background: rgba(235, 235, 235, 1);
	}

	.map-line-round {
		display: flex
	}

	.map-top {
		text-align: left;
		font-size: 15px;
		 
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 53px;
	}

	.map-bottom {
		text-align: left;
		font-size: 30px;
		 
		font-weight: 300;
		color: rgba(164, 164, 164, 1);
		line-height: 53px;
	}

	.map-bottom.active {
		color: rgba(0, 199, 133, 1);
		border-bottom: 0.0625rem !important;
		font-weight: 550;
	}

	.lf-course-right {
		display: flex;
		height: 260px;

	}

	.lf-course-right-total {
		user-select: none;
	}

	.map-top-one {
		text-align: left;
		font-size: 15px;
		 
		font-weight: 500;
		color: rgba(164, 164, 164, 1);
		line-height: 53px;
	}

	.map-bottom-one {
		text-align: left;
		font-size: 30px;
		 
		font-weight: 300;
		color: rgba(164, 164, 164, 1);
		line-height: 53px;
	}

	.lf-course .signRight {
		margin-left: 4px;


	}

	.show-next .next {
		margin-left: 30px;
	}
</style>
